import { supabase } from '../../core/config/supabase';
import { SubscriptionEntity } from '../entities';
import { logger } from '@/src/core/utils';

export class SubscriptionDataSource {
  async getSubscription(userId: string): Promise<SubscriptionEntity | null> {
    logger.debug('SubscriptionDataSource', 'Fetching subscription', { userId });

    const { data, error } = await supabase.rpc('get_user_subscription', {
      p_user_id: userId,
    });

    if (error) {
      logger.error('SubscriptionDataSource', 'getSubscription failed', { error });
      throw new Error(error.message);
    }

    if (!data || data.length === 0) return null;

    return data[0] as SubscriptionEntity;
  }

  async countActiveTournaments(userId: string): Promise<number> {
    const { data, error } = await supabase.rpc('count_active_tournaments', {
      p_user_id: userId,
    });

    if (error) {
      logger.error('SubscriptionDataSource', 'countActiveTournaments failed', { error });
      throw new Error(error.message);
    }

    return data ?? 0;
  }

  async countActiveLeagues(userId: string): Promise<number> {
    const { data, error } = await supabase.rpc('count_active_leagues', {
      p_user_id: userId,
    });

    if (error) {
      logger.error('SubscriptionDataSource', 'countActiveLeagues failed', { error });
      throw new Error(error.message);
    }

    return data ?? 0;
  }

  async countPrivateTournaments(userId: string): Promise<number> {
    const { data, error } = await supabase.rpc('count_private_tournaments', {
      p_user_id: userId,
    });

    if (error) {
      logger.error('SubscriptionDataSource', 'countPrivateTournaments failed', { error });
      throw new Error(error.message);
    }

    return data ?? 0;
  }

  async countActiveTeams(userId: string): Promise<number> {
    const { data, error } = await supabase.rpc('count_active_teams', {
      p_user_id: userId,
    });

    if (error) {
      logger.error('SubscriptionDataSource', 'countActiveTeams failed', { error });
      throw new Error(error.message);
    }

    return data ?? 0;
  }
}
